import ZoomExample from "./ZoomExample/ZoomExample";


export default {
    id:"useZoomGesture",
    type:"(options:object):void",
    preview:ZoomExample,
    options:[
        {
            name:"element",
            type:"HTMLElement",
            description:"Element to zoom",
        },
        {
            name:"minScale",
            type:"number",
            description:"Minimun scale value, default to 1",
        },
        {
            name:"maxScale",
            type:"number",
            description:"Maximum scale value, default to 10",
        },
        ...["onZoomStart","onZoom"].map((name,i,{length})=>({
            name,
            type:"(event:ZoomEvent):void",
            props:((i+1)===length)&&[
                {
                    name:"ZoomEvent",
                    type:{
                        name:"PinchEvent",
                        hash:"usePinchGesture",
                    },
                    props:["X","Y"].map(axis=>({
                        name:"translate"+axis,
                        type:"number",
                        description:`Element translate${axis} value in pixels`,
                    })),
                }
            ],
        })),
        {name:"onZoomEnd",type:"():void"},
    ],
}
